import './creditcalcController.js';
import './creditcalcServices.js';

import 'Sass/views/credit-calculator.scss';